module.exports = __webpack_public_path__ + "static/media/ticker_icon_temp.7fc77c07.svg";